<template>
  <v-container pa-3>
    <v-layout align-center justify-center column>
      <v-flex xs12 md8 lg6>
        <h3 class="display-1 mb-3 mt-5 text-xs-center">About Us</h3>
        <v-card max-width="800">
          <v-card-title primary-title>
            <div>
              <h4 class="headline mb-0 blue-grey--text text--darken-2">
                {{ profile.name }}
              </h4>
              <p class="subheading grey--text">{{ profile.title }}</p>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <div class="text-xs-center mt-4 mb-2">
            <img
              :src="profile.avatar"
              :alt="profile.name"
              class="img--rounded"
            />
          </div>
          <v-card-text class="pa-4 body-1">
            <span class="whitespace">{{ profile.bio }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="info" :to="{ name: 'about' }">Read More</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'TheHomePageAbout',
  data() {
    return {
      profile: {
        avatar: require('../assets/PR_Properties_Las_Vegas_Real_Estate_Phil_Roy_250w.jpg'),
        name: 'Philip A Roy',
        title: 'Real Estate Broker',
        bio:
          'Philip Roy began his real estate career in Scottsdale, Arizona in 1988 after finishing college at Arizona State University. Phil worked in both residential and commercial real estate until the local real estate market overbuilt itself in mid 1990. The greater Phoenix area became so overbuilt that the demand for real property totally ceased and therefore Phil was forced to make a career change. Phil owned an aircraft at the time the real estate market collapsed and decided that he would like to fly professionally. In July of 1990 Phil moved to Las Vegas and became a professional pilot.' +
          '\n\n' +
          "After more than a decade of being a professional pilot, Phil decided that he wanted to get back into real estate. Phil obtained his Nevada real estate Broker's license and formed PR Properties Group. Phil was so busy that he decided to take a leave of absence from his airline job so he could practice real estate full time. Phil has amassed over One Hundred Sixty Million Dollars in Closed Commercial and Residential Real Estate Transactions in the last few years.",
      },
    };
  },
};
</script>

<style scoped>
img {
  max-width: 250px;
}

.img--rounded {
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px;
}

.whitespace {
  white-space: pre-wrap;
}
</style>
